import { render, staticRenderFns } from "./StockInventoryDetail.vue?vue&type=template&id=ab7385b2&"
import script from "./StockInventoryDetail.vue?vue&type=script&lang=js&"
export * from "./StockInventoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./StockInventoryDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports